import * as React from 'react';
import { MutationFunc } from 'react-apollo';

import { Button } from '../../modules/modules';
import { PayPal } from '../GatewayComponent';
import AuthorizeNetButton from '../GatewayComponent/AuthorizeNetButton';
import { canOrderPaid } from 'helpers/src/orders/canOrderPaid';
import { getPaymentFailed } from '../../helpers/payment/getPaymentFailed';

interface IOrderPayButtonProps {
  order: GQL.IOrder;
  payment?: GQL.IPayment;
  nextData?: string; // todo: fuj !!!
  onClick: () => void;
  onRefetch: () => void;
  handleCreatePayment: MutationFunc;
  setPaymentStatus?: MutationFunc;
}

class OrderPayButton extends React.Component<IOrderPayButtonProps> {

  public render() {
    const { order, payment, nextData } = this.props;

    const btnProps = {
      disabled: false,
      onClick: this.props.onClick,
      style: {},
    };

    // popis tlačítka podle stavu platby
    const btnCaption = getPaymentFailed(payment) ? `Repeat payment` : `Make payment`;

    // objednávka nemůže být zaplacena
    if (!canOrderPaid(order)) {
      btnProps.disabled = true;
    }

    const disablePayMessage = 'When shipping cost is calculated, you receive an e-mail with a payment request.';

    // paypal
    if (order && order.paymentMethod && order.paymentMethod.gateway === 'paypal') {
      return (
        <>
          {!canOrderPaid(order) &&
            <span className="disable-pay-message">{disablePayMessage}</span>}
          <PayPal
            // todo: neměl by mít order povinnou měnu ?!
            btnCaption={btnCaption}
            disabled={btnProps.disabled}
            order={order}
            currency={order.currency && order.currency.value ? order.currency.value : ''}
            createPayment={this.props.handleCreatePayment}
            onRefetch={this.props.onRefetch}
            variables={{ variables: {
              orderNumber: order.orderNumber,
              language: order.language,
              paymentMethod: order.paymentMethod,
            }}}
          />
        </>
      );
    }

    // gp webpay
    // if (order && order.paymentMethod && order.paymentMethod.gateway === 'gpwebpay') {
    //   // platba byla stornována
    //   if (payment && payment.status === 'canceled') {
    //     btnProps.disabled = true;
    //     btnProps.style = { height: 'auto' };
    //     btnCaption = 'Payment cannot be repeated';
    //   }
    // }

    // authorize.net
    if (order && order.paymentMethod && order.paymentMethod.gateway === 'authorizenet') {
      return (
        <>
          {!canOrderPaid(order) &&
            <span className="disable-pay-message">{disablePayMessage}</span>}
          <AuthorizeNetButton
            btnCaption={btnCaption}
            nextData={nextData} // todo: fuj !!!
            order={order}
            payment={payment}
            disabled={btnProps.disabled}
            createPayment={this.props.handleCreatePayment}
            setPaymentStatus={this.props.setPaymentStatus}
            onRefetch={this.props.onRefetch}
          />
        </>
      );
    }

    return (
      <>
        {!canOrderPaid(order) &&
          <span className="disable-pay-message">{disablePayMessage}</span>}
        <Button type={'red btn--lg'} {...btnProps}>
          {btnCaption}
        </Button>
      </>
    );
  }
}

export default OrderPayButton;


// WEBPACK FOOTER //
// ./src/components/OrderPayButton/OrderPayButton.tsx